<template>
  <div v-loading.fullscreen.lock="loading" class="exchange_detail">
    <div v-show="!showSin">
      <!-- 头部 -->
      <top-part :rightPart="true"></top-part>
      <!-- 头部 结束 -->
      <div v-if="detailData" class="ctn_top">
        <div class="detail_Ctn">
          <div class="my_flex">
            <div>收货人：</div>
            <div class="address_2_text">
              <div class="address_name">{{ detailData.staffName || "" }}</div>
              <div>{{ detailData.staffPhone || "" }}</div>
            </div>
          </div>
          <div class="my_flex" style="padding-top: 0">
            <div>收货地址：</div>
            <div style="max-width: 70%; line-height: 20px">
              {{ detailData.addressDetails || "" }}
            </div>
          </div>
        </div>

        <div class="detail_Ctn">
          <div class="goods_list border_good" @click="toGoodsDetail">
            <div>
              <img :src="detailData.productImage || ''" />
              <div class="goods_count">
                <div>{{ detailData.productName || "" }}</div>
                <div>x1</div>
              </div>
            </div>
            <img src="@/images/icon_right.png" alt />
          </div>
          <div class="my_flex border_good">
            <div>兑换时间</div>
            <div>{{ detailData.createDate || "" }}</div>
          </div>
          <div class="my_flex border_good">
            <div>订单编号</div>
            <div>{{ detailData.orderId || "" }}</div>
          </div>
          <div class="my_flex border_good">
            <div>快递公司</div>
            <div>{{ detailData.expressCompanyName || "" }}</div>
          </div>
          <div class="my_flex">
            <div>快递单号</div>
            <div>{{ detailData.trackingNumber || "" }}</div>
          </div>
        </div>

        <div class="my_flex detail_Ctn">
          <div style="line-height: 20px">
            确认收货<span class="star_goods">*</span>并签名
          </div>

          <div v-if="signatureData" class="signature_complete">
            <img class="sign-img" :src="signatureData" />
            <span @click="toSignature" class="resign-txt">重新签名</span>
          </div>
          <div class="signature_edit" @click="toSignature" v-else>
            <div>
              <img src="@/images/edit.png" alt /><span class="no_singature"
                >签名</span
              >
            </div>
          </div>
        </div>

        <div class="tip_goods">请确认收到货物后签名</div>

        <!-- 打电话 -->
        <div
          class="btn_order"
          @click="onCall"
          v-if="supplierInfo.supplierPhone"
        >
          联系商家
        </div>
        <a
          id="call-phone"
          :href="'tel:' + supplierInfo.supplierPhone"
          hidden
        ></a>
        <!-- 打电话 结束-->
      </div>
      <!-- 没数据时 -->
      <div class="blank" v-else>
        <img src="@/images/404-02.png" alt />
      </div>
    </div>

    <!-- 签名 -->
    <div v-show="showSin" style="position: fixed; top: 0" v-loading="loading">
      <signature @closePop="closePop" @saveImg="upload"></signature>
    </div>
    <!-- 签名 结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import topPart from "../../components/topPart";
import signature from "../../components/signature.vue";
import { toast } from "@/common/api/api.js";
export default {
  components: {
    topPart,signature
  },
  data() {
    return {
      loading:true,
      showSin: false,
      detailData:{},//详情数据
      supplierInfo:{},//供应商数据
      phone:'',
      signatureData:'',//签名图片
      category:''
    };
  },
  mounted(){
    console.log('详情type',this.$route.query)
    this.category = this.$route.query.detailsType
    this.queryFn();
  },
  methods:{
    // 获取详情
    queryFn(){
      const {id,detailsType} = this.$route.query;
      this.centralControl.axios.centralControl(
        "orderList",
        res => {
          this.loading=false;
          const {code,message,data} = res;
          if (code == 200) {
            const {list,total}=data;
            this.detailData=list&&list[0];
            this.supplierInfo=this.detailData&&this.detailData.supplierInfo;
            this.signatureData=this.detailData.signature;
            // console.log(this.signatureData)
          } else {
            toast(this, message,"error");
          }
        },
        {orderId:id,welfareCategory:detailsType}
      );
    },
    // 跳转至商品
    toGoodsDetail(){
      const {productId,welfareId}=this.detailData;
      if(!productId||!welfareId)return;
      this.$router.push({
        path:'goodsDetail',
        query:{
          id:productId,
          welfareId,
          disabled:true,
          welfareCategory: this.category
        }
      })
    },
    // 打电话
    onCall() {
      const el = document.getElementById('call-phone');
      el.target = '_new'; // 指定在新窗口打开
      el.click(); // 触发打开事件
    },
    closePop() {
      this.showSin = false;
    },
    // 签名确认后
    upload(data) {
      if(data)this.signatureData=data;
      const {id} = this.$route.query;
      let params={
        signature:data,
        id,
        welfareCategory: this.category
      }
      this.centralControl.axios.centralControl(
        "saveOrder",
        res => {
          this.loading=false;
          const {code,message,data} = res;
          if (code == 200) {
            this.queryFn();
          } else {
            toast(this, message,"error");
          }
        },
        params
      );


      this.closePop();
    },
    toSignature(){
      this.showSin = true;
    }
  }
}
</script>
<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/common"
@import '../../assets/stylus/theme.styl';
  .exchange_detail{
    .tip_goods {
      color: #FF4B4B;
      margin-left: 16px;
      font-size:12px;
      font-family:PingFang-SC-Medium,PingFang-SC;
      font-weight:500;
      color:rgba(255,75,75,1);
      margin-bottom: 26px;
    }
    .star_goods {
      color: #FF1919;
      margin-left: 2px;
    }
    .my_flex {
      padding: 14px 16px;
      line-height: 24px;
      display: flex;
      >div:nth-child(1){
        width: 76px;
        margin-right: 18px;
        font-size:14px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(53,53,53,1);
      }
      >div:nth-child(2){
        font-size:14px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(136,136,136,1);
      }
    }
    .detail_Ctn {
      background: #FFF;
      margin-bottom: 10px;
      .border_good{
        border-bottom: 1px solid #F5F6FB;
      }
      .goods_list {
        display: flex;
        margin-top: 10px;
        padding: 12px 0 12px 16px;
        justify-content: space-between;
        align-items: center;
        >div:nth-child(1){
          display :flex;
          align-items: center;
          img {
            width: 48px;
            height: 48px;
            margin-right: 16px;
          }
        }
        .goods_count {
          height: 40px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          >div:nth-child(1){
            font-size:16px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
            color:rgba(53,53,53,1);
          }
          >div:nth-child(2){
            font-size:13px;
            font-family:PingFang-SC-Medium,PingFang-SC;
            font-weight:500;
            color:rgba(202,202,210,1);
          }
        }
        // .goods_right {
            img {
            width: 26px;
            // margin-top: 16px;
          // }
        }
      }
    }
    .signature_edit {
      width:252px;
      height:40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border:1px solid rgba(41,190,188,1);
      .no_singature {
        display:inline-block;
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(41,190,188,1);
        line-height:22px;
        }
      img {
        width: 16px;
        margin-right: 4px;
      }
    }
    .signature_complete {
      height: 59px;
      width: 48%;
      margin-left: 81px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sign-img {
        width: 70px;
        height: 130px;
        transform: rotate(90deg);
      }
      .resign-txt {
        color: $default-color;
        font-size: 12px;
        font-style: italic;
        display: inline-block;
        text-align: center;
      }
    }
  }
</style>
